/**
 * Created by greg on 18/07/2018.
 */
import { Injectable } from '@angular/core';
import { DocumentData, docSnapshots, DocumentReference, Firestore, onSnapshot, DocumentSnapshot, CollectionReference, collectionChanges, DocumentChange, Query, WhereFilterOp, query, collection, QueryFieldFilterConstraint } from '@angular/fire/firestore';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs';
import { LogService } from 'src/app/services/log.service';


// To do - create snapshotChanges() method, and replace all subscriptions to that and the stateChanges() functions to the

@Injectable({ providedIn: 'root' })
export class SubscriptionHelper {
  constructor(public db: Firestore, private log: LogService) {}

  subscribeToDocumentSnapshotChanges<T>(doc: DocumentReference<T, DocumentData>, changesHandler: (changes:DocumentSnapshot<T, DocumentData>) => void, stopper: Subject<boolean>, callingFile: string = 'anonymous subscribeToCollection', callingFunction: string = 'unknown calling function') {
    docSnapshots(doc).pipe(
      tap({next: changesHandler, error: (response)=>{
          this.log.error({file: callingFile, function: callingFunction, response, error:new Error()})
        }
      }),
      takeUntil(stopper)
    ).subscribe({ error:response=>{
          let message = 'There was an error subscribing to document snapshot changes'
          if (response.code === 'permission-denied') {
            message = 'You do not have the proper permissions'
          }
          console.log("ERROR DOWN HERE", { response })
          this.log.error({file: callingFile, function: callingFunction, response, message, error:new Error()})
        }
    })
  }

  subscribeToCollectionsWithHandlerAndStopper<T>(query: Query<T>, collectionName: string, changesHandler: (changes: DocumentChange<T>[]) => void, stopper: Subject<boolean>, callingFile: string = 'anonymous subscribeToCollection', callingFunction: string = 'unknown calling function'): Promise<void> {
    // promise resolves when every subscription has fired at least once (subscriptions will fire even when empty)
    return new Promise((resolve, reject) => {
      let resolved = false
      const budgetsQuery: Query<T> = query
        collectionChanges(budgetsQuery).pipe(tap({next:(changes:DocumentChange<T>[]) => {
          resolve()
          changesHandler(changes)
        }, error: response => {
          resolve()
          this.log.error({file: callingFile, function: callingFunction,response,error:new Error()})
        }}), takeUntil(stopper)).subscribe()}
      )
  }
}
